import { DatabaseService, Client, ClientData, ClientRepository } from "@/core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getClientRepository(
  databaseService: DatabaseService,
): ClientRepository {
  return getGenericRepository<Client, ClientData>(
    () => DatabaseCollection.CLIENTS,
    databaseService,
  );
}

